var map = {
	"./1.png": 3430,
	"./2.png": 3431,
	"./3.png": 3432,
	"./4.png": 3433
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 678;



//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/smilies .\.png*
// module id = 678
// module chunks = 0